// Centralised enum definitions — replaces scattered string literals

export enum Feature {
  PROJECTS = 'projects',
  UPLOAD = 'upload',
  SEARCH = 'search',
  CONNECTIONS = 'connections',
  LISTS = 'lists',
  REVIEWS = 'reviews',
  ADMIN = 'admin',
  USER_MANAGEMENT = 'user-management',
  AUDIT = 'audit',
  SECURITY = 'security',
}

// Cognito challenge names returned by InitiateAuth / RespondToAuthChallenge.
// Values are the EXACT strings AWS Cognito emits — they must never change.
// (MFA plan Phase 1 / D6 extends this from the original SMS-only pair to cover
// the TOTP, email-OTP and method-selection challenges the login flow now
// answers.)
export enum MfaChallengeType {
  SMS_MFA = 'SMS_MFA',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
  EMAIL_OTP = 'EMAIL_OTP',
  SELECT_MFA_TYPE = 'SELECT_MFA_TYPE',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  // Story #4709: issued at InitiateAuth when the pool is mfa_configuration=ON
  // and the user has zero enrolled devices — there is no code to verify yet,
  // the user must associate one first (ChallengeParameters.MFAS_CAN_SETUP).
  MFA_SETUP = 'MFA_SETUP',
}

// The second-factor method tokens a user can be challenged with, or can pick
// between when Cognito emits SELECT_MFA_TYPE (ChallengeParameters.MFAS_CAN_CHOOSE
// carries these, and the SELECT_MFA_TYPE answer's `ANSWER` field is one of them).
// Values are identical to the corresponding challenge names, per Cognito.
export enum MfaMethod {
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
  SMS_MFA = 'SMS_MFA',
  EMAIL_OTP = 'EMAIL_OTP',
}

// The ChallengeResponses key that carries the user-entered code, per method.
// Cognito requires the method-specific key (e.g. a TOTP code MUST be sent as
// SOFTWARE_TOKEN_MFA_CODE, not SMS_MFA_CODE) — see mfaMethodToChallengeResponseKey().
export enum MfaResponseKey {
  SOFTWARE_TOKEN_MFA_CODE = 'SOFTWARE_TOKEN_MFA_CODE',
  SMS_MFA_CODE = 'SMS_MFA_CODE',
  EMAIL_OTP_CODE = 'EMAIL_OTP_CODE',
}

export enum SortOption {
  RELEVANCE = 'relevance',
  DATE = 'date',
  NAME = 'name',
}

export enum ConnectionLayout {
  COSE = 'cose',
  CIRCLE = 'circle',
  BREADTHFIRST = 'breadthfirst',
  GRID = 'grid',
}
